import { render, staticRenderFns } from "./log-reporter.vue?vue&type=template&id=780fc2b8&scoped=true"
import script from "./log-reporter.vue?vue&type=script&lang=js"
export * from "./log-reporter.vue?vue&type=script&lang=js"
import style0 from "./log-reporter.vue?vue&type=style&index=0&id=780fc2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780fc2b8",
  null
  
)

export default component.exports